import React from 'react';
import ChemComponent from './ChemComponent';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

class ADADatePicker extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.dpRef = React.createRef();
	}	

	componentDidMount() {
		this.addAutocomplete();
	}
	
	componentDidUpdate(prevProps) {
		this.addAutocomplete();
	}
	
	addAutocomplete()
	{
		if (this.dpRef.current && this.dpRef.current.input) {
			if (this.isEmpty(this.props.autoComplete)) {
				this.dpRef.current.input.autocomplete = 'off';
			} else {
				this.dpRef.current.input.autocomplete = this.props.autoComplete;
			}
			if (!this.isEmpty(this.props.ariaLabelledBy)) {
				this.dpRef.current.input['aria-labelledby'] = this.props.ariaLabelledBy;
			}
		}
	}

	render() {
		return (
			<DatePicker ref={this.dpRef} {...this.props} />
		);
	}
}

export default ADADatePicker;
